module.exports = __webpack_public_path__ + "img/44.1b280e1d.jpg";